<template>

  <b-card class="card-transaction" no-body  >
    <b-card-body >
          <b-row >
            <b-col >
                <b-form   inline class="justify-content-md-center">

                  <b-form-group  >
                    <label >Estabelecimento</label>
                    <b-form-select
          
                    class="mb-2 mr-sm-2 mb-sm-0 "
                        v-model="dados.estabelecimento"
                        :options="lista_estabelecimentos"
                        value-field="id"
                        text-field="name"
                      ></b-form-select>
                  </b-form-group>
  
                  <b-form-group  >
                      <label >Conta</label>
                      <b-form-select
            
                      class="mb-2 mr-sm-2 mb-sm-0 "
                          v-model="dados.conta"
                          :options="lista_contas"
                          value-field="id"
                          text-field="bank.name"
                        ></b-form-select>
                  </b-form-group>
  
                    <b-form-group>
                      <label >Valor</label>
                          <b-form-input
                            v-money="money"
                            v-model="dados.valor"
                            class="mb-2 mr-sm-2 mb-sm-0"
                            placeholder="Valor Total"
                          ></b-form-input>
                    </b-form-group>
  
                    <!-- <b-form-group>
                      <label >Data envio</label>
                          <b-form-input
                            v-model="dados.data_pedido"
                            class="mb-2 mr-sm-2 mb-sm-0"
                            placeholder="00/00/0000"
                            type="date"
                          ></b-form-input>
                    </b-form-group> -->
  
                    <b-form-group class="mb-2 mr-sm-2 mb-sm-0">
                      <label >-------</label>
  
                          <div class="text-center">
  
                            <b-button variant="gradient-primary "
                            v-if="!spiner"
                            block
                                @click="solicitarTransferencia()"
                              >
                                Enviar dinheiro
                            </b-button>
                        
                            <b-button
                            v-if="spiner"
                            block
                                variant="gradient-primary"
                                disabled
                                class="mr-1"
                              >
                                <b-spinner small />
                                Enviando
                            </b-button>
                            
                          </div>
                    </b-form-group>
                  
                </b-form>
            </b-col>
            
          </b-row>
      
     
      <b-tabs   >
        <b-row class="justify-content-md-center">
          <b-col md="10"  >
            <ListaEnvios></ListaEnvios>
          </b-col>
        </b-row>
      </b-tabs>
    </b-card-body>
  </b-card>
  
  </template>
  
  <script>
  import { BCard, BCardText, BLink,BRow, BCol, BTabs, BCardBody, BForm,BFormGroup, BFormInput, BButton, BFormSelect, BSpinner } from "bootstrap-vue";
  import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
  import ListaEnvios from './home/ListaEnvios'
  import {VMoney} from 'v-money'
 
  export default {
    components: {
      BRow,
      BCol,
      BCard,
      BCardText,
      BLink, ListaEnvios, BTabs, BCardBody,BForm,BFormGroup,BFormInput,BButton,BFormSelect,BSpinner
  },
  directives: {money: VMoney},
    data() {
      return {
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          // suffix: ' #',
          precision: 2,
          masked: false /* doesn't work with directive */
        },
     
        listaStatus: [{status:null,text:""},{status:3,text:"Confirmado"},{status:1,text:"Processando"},{status:2,text:"Cancelado"},{status:4,text:"Reservado"}],
        listaEstabelecimento: [{ id: null, text: '' },{text:"PEDRO JUAN CABALLERO",id:1},{text:"CIUDAD DEL ESTE LAGO",id:2},{text:"CIUDAD DEL ESTE KM 8",id:3}],
        dados: {estabelecimento:"",valor:"",data_pedido:"",conta:""},
        spiner:false,
  
      };
    },
  
    created() {
      this.$store.dispatch("estabelecimentos/all_estabelecimentos");
    },
    watch:{
      'dados.estabelecimento'(id){
            this.listarTransacao(id)
            this.$store.dispatch("estabelecimentos/getContasBancarias", id);
          },

     
    },
    computed: {
    lista_estabelecimentos() {
      return this.$store.state.estabelecimentos.lista_estabelecimentos.data;
    },

    lista_contas(){
      console.log(this.$store.state.estabelecimentos.contaEstabelecimento)
      return this.$store.state.estabelecimentos.contaEstabelecimento;
    }
  
  },
  
    methods: {
      
      formatPriceR(value) {
        let val = value.toFixed(2).replace(".", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },

      async solicitarTransferencia(){
       
        let dados = {
                  establishmentId: this.dados.estabelecimento,
                  amount: parseInt(this.dados.valor.replace("R$ ","").replace(".","").replace(".","").replace(".","").replace(",",".")),
                  bankAccountId:this.dados.conta
                }

                this.spiner = true
       
        await this.$store.dispatch("estabelecimentos/solicitarTransferencia", dados)
          .then((data) => {
  
            this.spiner = false
           this.listarTransacao(this.dados.estabelecimento)
          })
          .catch((error) => {
            this.spiner = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Erro:" + error,
                icon: "EditIcon",
                variant: "danger",
              },
            });
          
           
          });
          
      },
    async  listarTransacao(id){

         this.spiner = true
        
        await this.$store.dispatch("estabelecimentos/listarTransacao", id)
          .then((data) => {
  
            this.spiner = false
           
          })
          .catch((error) => {
            this.spiner = false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Erro:" + error,
                icon: "EditIcon",
                variant: "danger",
              },
            });
          
           
          });
        
       
      },
  
    },
  };
  </script>
  
  
  <style scoped>
  
  </style>